import styled from 'styled-components';
import { Button } from 'client/widgets/ui';
import { observer } from 'mobx-react';
import { useBoolean, useNumber, useSetState, useStateful } from 'react-hanger';
import { geetest, hooks, request, user, storage } from 'lib';
import assign from 'lodash/assign';
import { UiToast } from 'components';
import { getGlobalStore } from 'stores';
import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import Icon from '../../../../components/ui/icon';
import { useStore } from './store';
import { OneLogin, ToggleLogin } from './common';
import S from './styled';

const { Form, FormTip, FormItem, Input } = S;
const BtnSend = styled(Button)`
  margin-left: 12px;
  padding-left: 0;
  padding-right: 0;
  font-size: var(--fs-md) !important;
`;

const InputCode = styled(Input)`
  width: 100px;
`;

const MobileLogin = observer((props) => {
  const { show } = props;
  const { setLoginType } = useStore();
  const seconds = useNumber(0);
  const tip = useStateful('');
  const { query } = useRouter();

  const isLoading = useBoolean(false);
  const isChecked = useBoolean(false);
  const { state, setState, resetState } = useSetState({
    mobile: '',
    sms_code: '',
    password: '',
  });

  const onChange = (e) => {
    let { name, value } = e.currentTarget;

    if (name === 'mobile') {
      value = value.replace(/\D/g, '');
    }

    setState({
      [name]: value.replace(/[\u4e00-\u9fa5]|\s/g, ''),
    });
  };
  const checkMobile = () => {
    if (state.mobile.length !== 11) {
      tip.setValue('请填写有效的手机号');
      return false;
    }
    tip.setValue('');
    return true;
  };

  const checkData = () => {
    if (state.sms_code.length === 0) {
      tip.setValue('请填写验证码');
      return false;
    }

    if (state.password.length < 8 || state.password.length > 20) {
      tip.setValue('密码长度为8~20位');
      return false;
    }
    if (!/^(?![0-9a-z]+$)(?![a-zA-Z]+$)(?![0-9A-Z]+$)[0-9A-Za-z]{8,20}$/.test(state.password)) {
      tip.setValue('密码需同时包含大、小写字母和数字');
      return false;
    }

    tip.setValue('');
    return true;
  };

  hooks.useInterval(
    () => {
      seconds.decrease();
    },
    seconds.value > 0 ? 1000 : null,
  );

  const onSendCode = (e) => {
    if (state.mobile.length === 0) {
      return;
    }
    e.preventDefault();
    if (!checkMobile()) {
      return;
    }

    request.user
      .get('register/checkmobile', {
        mobile: state.mobile,
      })
      .then((res) => {
        geetest(
          'quick_login',
          (geetestData, captchaObj) => {
            // let isChina = currentCountry.value.country === '中国';
            let data = {
              mobile: state.mobile,
              // nation_code: '+86',
              type: 1,
              china: true,
              code: 'destsaz' + Math.floor(Math.random() * 100),
            };
            data = assign(data, geetestData);
            captchaObj.reset();

            request.user
              .get({
                url: 'authcode/new_send_mobile',
                contentType: 'JSON',
                data,
              })
              .then(() => {
                seconds.setValue(60);
                UiToast.success('验证码发送成功');
              })
              .catch((res) => {
                tip.setValue(res.msg || '验证码发送失败');
              });
          },
          () => {
            tip.setValue('校验异常');
          },
          () => {},
        );
      })
      .catch((res) => {
        const msgs = {
          30433: '该手机号已绑定其他么么号，请更换手机号',
        };
        UiToast.warn(msgs[res.code] || res.msg || '手机号不可用');
      });
  };

  const onLogin = (e) => {
    if (!isChecked.value) {
      UiToast.info('请先阅读协议并同意');
      return;
    }

    if (isDisableSubmit) {
      return;
    }
    e.preventDefault();
    if (!checkMobile()) {
      return;
    }

    if (checkData() && !isLoading.value) {
      isLoading.setTrue();
      user.register({
        ...state,
        pwd: state.password,
        onSuccess: () => {
          isLoading.setFalse();
          // const { userInfo } = getGlobalStore();
          // if (!userInfo.isAnchor) {
          //   user.clearUserInfo();
          //   tip.setValue('登录失败，请先申请开播获得主播权限');
          //   return false;
          // }
        },
        onFail: (msg) => {
          tip.setValue(msg);
          isLoading.setFalse();
        },
      });
    }
  };

  const isDisableSubmit = state.mobile.length === 0 || state.sms_code.length === 0;
  return (
    <Form show={show}>
      <FormItem>
        <Input
          placeholder="请输入手机号"
          name="mobile"
          value={state.mobile}
          type="tel"
          maxLength={11}
          onChange={onChange}
        ></Input>
      </FormItem>
      <FormItem>
        <InputCode
          placeholder="请输入验证码"
          name="sms_code"
          maxLength={6}
          value={state.sms_code}
          onChange={onChange}
        ></InputCode>
        {seconds.value > 0 ? (
          <BtnSend type="primary" round size="lg" disable>
            {seconds.value}秒后重新获取
          </BtnSend>
        ) : (
          <BtnSend
            type="primary"
            round
            size="lg"
            disable={state.mobile.length === 0}
            onClick={onSendCode}
          >
            获取验证码
          </BtnSend>
        )}
      </FormItem>

      <FormItem>
        <Input
          placeholder="设置密码(大、小写字母和数字，8-20位)"
          type="password"
          name="password"
          maxLength={20}
          minLength={8}
          value={state.password}
          onChange={onChange}
        ></Input>
      </FormItem>
      <FormTip>{tip.value}</FormTip>
      <FormItem>
        <ToggleLogin
          onClick={() => {
            setLoginType('password');
          }}
        >
          密码登录
        </ToggleLogin>
        <ToggleLogin className="bar">|</ToggleLogin>
        <ToggleLogin
          onClick={() => {
            setLoginType('mobile');
          }}
        >
          验证码登录
        </ToggleLogin>
        <span className="blank"></span>
      </FormItem>
      <FormItem>
        {isLoading.value ? (
          <Button type="primary" size="lg" disable round block>
            加载中...
          </Button>
        ) : (
          <Button type="primary" size="lg" round block disable={isDisableSubmit} onClick={onLogin}>
            注&nbsp;册
          </Button>
        )}
      </FormItem>
      <div className="desc">
        <S.Radio onClick={isChecked.toggle} $check={isChecked.value}>
          <Icon type={isChecked.value ? 'circle-check-fill' : 'circle'}></Icon>{' '}
          <span>我已阅读并同意</span>
        </S.Radio>
        <a
          href="https://www.2339.com/notice/10097"
          target="_blank"
          data-sawebclick="id=tc007b004&desc=么么直播协议"
        >
          《么么直播用户协议》
        </a>
        <a href="https://www.2339.com/notice/10468" target="_blank">
          《么么直播隐私政策》
        </a>
      </div>
      <FormItem style={{ marginTop: 0 }}>
        <OneLogin></OneLogin>
      </FormItem>
    </Form>
  );
});

export default MobileLogin;
